/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Post_Purchase_Welcome_HeadingInputs */

const en_post_purchase_welcome_heading = /** @type {(inputs: Post_Purchase_Welcome_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welcome to Listening`)
};

const es_post_purchase_welcome_heading = /** @type {(inputs: Post_Purchase_Welcome_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bienvenido a Listening`)
};

/**
* | output |
* | --- |
* | "Welcome to Listening" |
*
* @param {Post_Purchase_Welcome_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const post_purchase_welcome_heading = /** @type {((inputs?: Post_Purchase_Welcome_HeadingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Post_Purchase_Welcome_HeadingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_post_purchase_welcome_heading(inputs)
	return en_post_purchase_welcome_heading(inputs)
});